import { Photo } from '@/shared/api/photos'
import { PhotoCard } from './PhotoCard'
import { cn } from '@/shared/utils'

interface PhotoGridProps {
  photos: Photo[]
  onPhotoClick: (photo: Photo) => void
  onDeletePhoto?: (photoId: string) => Promise<void>
  className?: string
  coverPhotoId?: string | null
  isDeleting?: boolean
}

export function PhotoGrid({ photos, onPhotoClick, onDeletePhoto, className, coverPhotoId, isDeleting }: PhotoGridProps) {
  if (photos.length === 0) {
    return (
      <div className={cn('text-center py-12 text-gray-500', className)}>
        <p className="text-sm">No photos yet</p>
        <p className="text-xs mt-1">Upload photos to get started!</p>
      </div>
    )
  }

  return (
    <div
      className={cn(
        'grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4',
        className
      )}
    >
      {photos.map((photo) => (
        <PhotoCard
          key={photo.id}
          photo={photo}
          onClick={onPhotoClick}
          onDeletePhoto={onDeletePhoto}
          coverPhotoId={coverPhotoId}
          isDeleting={isDeleting}
        />
      ))}
    </div>
  )
}
